import moment from 'moment';
import React from 'react';
import { generateTimeString } from 'src/utils/scorecard';

interface Props {
	interviewedOn: {
		startTime: string;
		duration: number;
	};
}

const TechnicalRoundInterviewedOn = ({ interviewedOn }: Props) => {
	const { startTime, duration } = interviewedOn;
	const dateString = moment(startTime).format('DD MMMM YYYY');
	const timeString = generateTimeString(startTime, duration);
	return (
		<div className="md:pl-[10px] md:border-l-[1px] md:border-solid md:border-[#00CFDE]">
			<div className="text-sm dark:text-[#E5FFFF] text-[#28293D]">Interviewed on</div>

			<div className="mt-3">
				<div className="text-base font-medium dark:text-white text-[#28293D]">{dateString}</div>
				<div className="text-sm dark:text-[#E4E4EB] text-[#28293D] mt-1">{timeString}</div>
			</div>
		</div>
	);
};

export default TechnicalRoundInterviewedOn;
